module.exports = __webpack_public_path__ + "static/media/general-retail.2a4ea697.svg";